import React, { useEffect, useState } from "react";
import MenuBottom from "../../Component/menuBottom/MenuBottom";
import Style from "./SuperMarketAround.module.css";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import { getSupermarketsList } from "../../Api/BarestServices";
import SupermarketListScroll from "../../Component/SupermarketListScroll/SupermarketListScroll";
import { getSearchSuperyApi } from "../../Api/ClientServices";
import { Link } from "react-router-dom";
import { errorToast } from "../../Toast/Toast";

const SupermarketsAround = () => {
  const [Data, setData] = useState();
  const [filter, setFilter] = useState("");
  const [searchValue, setSearchValue] = useState(false);
  const [showSearchPart, setShowSearchPart] = useState();
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    getListSupermarket();
  }, []);

  const getSearchSupermarket = async (value) => {
    getSearchSuperyApi(value, (succ, res) => {
      if (succ) {
        if (res.status === 0) {
          setShowSearchPart(false);
        } else {
          if (res.product?.length === 0 || res.product === null) { 
            setShowSearchPart(false);
          } else {
            setSearchValue(res.product);
            setShowSearchPart(true);
          }
        }
      } else {
        console.error(res);
      }
    });
    setSearchInput(value);
  };

  const getListSupermarket = async () => {
    getSupermarketsList((succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setData(res.suppliers);
        }
      } else {
        console.error(res);
      }
    });
  };

  let Loading = null;
  if (Data === undefined) {
    Loading = (
      <div style={{ display: "flex", justifyContent: "center" }}>
        {" "}
        <PointSpreadLoading color={"#ab0c59"} size={"small"} />
      </div>
    );
  } else {
    const sorted = [...Data].sort((a, b) => {
      return a.working_hours.open === "1" ? -1 : 1;
    });
    Loading = (
      <SupermarketListScroll
        searchInput={filter}
        data={sorted}
        splice={false}
      />
    );
  }

  return (
    <div className={Style.PageHolder}>
      <div className={Style.fixPage}>
        <BurgerMenuTitle title={"سوپرمارکت"} />
        <div className={Style.searchHolder}>
          <input
            className={Style.search}
            placeholder={"جستجو ..."}
            onChange={(e) => getSearchSupermarket(e.target.value)}
            type={"text"}
          />
          {searchInput.length === 0 || !showSearchPart ? null : (
            <ul className={Style.searchResult}>
              {searchValue?.map((item, index) => {
                return (
                  <Link
                    to={{
                      pathname: `/product/${item.id}/${item.supplier_id}`,
                      state: item.id,
                    }}
                    className={Style.resultItem}
                    key={index}
                  >
                    <div className={Style.imgHolder}>
                      <img
                        src={`https://cdn.barest.ir/product/m/${item.id}.jpg`}
                        alt={item.name}
                      />
                    </div>
                    <div className={Style.productInfo}>
                      <h3 className={Style.productName}>{item.name}</h3>
                      {/* <h3 className={Style.supplierName}>
                        <FontAwesomeIcon
                            icon={faShoppingBag}
                            className={Style.shopIcon}
                        />
                        {item.supplier_name}
                        </h3> */}
                      <div className={Style.priceHolder}>
                        {item.off_price === 0 ? null : (
                          <h3 className={Style.offPrice}>
                            {item.off_price}تومان
                          </h3>
                        )}
                        {item.off_price === 0 ? (
                          <h3 className={Style.price}>{item.price}تومان</h3>
                        ) : (
                          <h3 className={Style.ofprice}>{item.price}تومان</h3>
                        )}
                      </div>
                    </div>
                  </Link>
                );
              })}
              <div className={Style.opacityPart}></div>
            </ul>
          )}
        </div>
        <h3 className={Style.titleHolder}>فروشگاه ها براساس فاصله از شما</h3>
        {Loading}
        <MenuBottom />
      </div>
    </div>
  );
};
export default SupermarketsAround;
